// extracted by mini-css-extract-plugin
export default {"drawinglabelContainer":"DrawingLabelModal_drawinglabelContainer__4FUN0"};